export const MPTNCVAL = {
    NOT_READ: 0,
    ACCEPT: 1,
    REJECT: 2
}

export const MP_ROLES = ['ROOT Admin', 'ZP Admin', 'Client Admin', 'Client User'];

export const MP_SALES_ORG = ['2001', '2025']

export const TRUE = 'true'

export const ORDER_FILTER_VALUE = {
    ALL: 0,
    MP: 1,
    ZP: 2,
    SP: 3
}

export const ORDER_FEE_TYPE = {
    ALL: 'ALL',
    MP: "MP",
    ZP: "ZP"

}